/**
 * FluidPropertiesData
 * Embedded glycol fluid property data (density and specific heat)
 * Optimized for minimal size - only the most commonly used temperature range
 */

// Density data (lbm/ft³) - Ethylene Glycol (key temperatures only)
const ethyleneGlycolDensity = {
  temperatures: [0, 20, 40, 60, 80, 100, 120, 140, 160, 180, 200],
  concentrations: [10, 20, 30, 40, 50, 60, 70, 80, 90],
  data: {
    '0': { '50': 67.7, '60': 68.6, '70': 69.5 },
    '20': { '20': 64.6, '30': 65.6, '40': 66.6, '50': 67.5, '60': 68.4, '70': 69.2, '80': 70.1, '90': 70.9 },
    '40': { '10': 63.5, '20': 64.5, '30': 65.4, '40': 66.4, '50': 67.3, '60': 68.1, '70': 69, '80': 69.8, '90': 70.6 },
    '60': { '10': 63.3, '20': 64.3, '30': 65.2, '40': 66.1, '50': 67, '60': 67.8, '70': 68.7, '80': 69.5, '90': 70.2 },
    '80': { '10': 63.1, '20': 64, '30': 64.9, '40': 65.8, '50': 66.7, '60': 67.5, '70': 68.3, '80': 69.1, '90': 69.8 },
    '100': { '10': 62.8, '20': 63.8, '30': 64.7, '40': 65.5, '50': 66.4, '60': 67.2, '70': 67.9, '80': 68.7, '90': 69.4 },
    '120': { '10': 62.5, '20': 63.4, '30': 64.3, '40': 65.2, '50': 66, '60': 66.8, '70': 67.5, '80': 68.2, '90': 68.9 },
    '140': { '10': 62.2, '20': 63.1, '30': 63.9, '40': 64.8, '50': 65.6, '60': 66.3, '70': 67.1, '80': 67.7, '90': 68.4 },
    '160': { '10': 61.8, '20': 62.7, '30': 63.5, '40': 64.3, '50': 65.1, '60': 65.9, '70': 66.6, '80': 67.2, '90': 67.8 },
    '180': { '10': 61.4, '20': 62.3, '30': 63.1, '40': 63.9, '50': 64.6, '60': 65.3, '70': 66, '80': 66.7, '90': 67.3 },
    '200': { '10': 61, '20': 61.8, '30': 62.6, '40': 63.4, '50': 64.1, '60': 64.8, '70': 65.4, '80': 66.1, '90': 66.6 }
  }
};

// Density data (lbm/ft³) - Propylene Glycol (key temperatures only)
const propylenGlycolDensity = {
  temperatures: [0, 20, 40, 60, 80, 100, 120, 140, 160, 180, 200],
  concentrations: [10, 20, 30, 40, 50, 60, 70, 80, 90],
  data: {
    '0': { '40': 66.15, '50': 66.77, '60': 67.23, '70': 67.55, '80': 67.71 },
    '20': { '20': 64.3, '30': 65.14, '40': 65.84, '50': 66.4, '60': 66.82, '70': 67.1, '80': 67.24 },
    '40': { '10': 63.21, '20': 64.1, '30': 64.87, '40': 65.5, '50': 66.01, '60': 66.39, '70': 66.64, '80': 66.77 },
    '60': { '10': 63.06, '20': 63.87, '30': 64.56, '40': 65.14, '50': 65.6, '60': 65.94, '70': 66.17, '80': 66.27 },
    '80': { '10': 62.85, '20': 63.59, '30': 64.22, '40': 64.75, '50': 65.17, '60': 65.47, '70': 65.68, '80': 65.77 },
    '100': { '10': 62.59, '20': 63.27, '30': 63.85, '40': 64.33, '50': 64.71, '60': 64.99, '70': 65.17, '80': 65.25 },
    '120': { '10': 62.28, '20': 62.9, '30': 63.43, '40': 63.87, '50': 64.22, '60': 64.48, '70': 64.65, '80': 64.72 },
    '140': { '10': 61.92, '20': 62.49, '30': 62.99, '40': 63.39, '50': 63.72, '60': 63.96, '70': 64.11, '80': 64.18 },
    '160': { '10': 61.5, '20': 62.04, '30': 62.5, '40': 62.88, '50': 63.19, '60': 63.41, '70': 63.55, '80': 63.62 },
    '180': { '10': 61.03, '20': 61.54, '30': 61.98, '40': 62.35, '50': 62.63, '60': 62.85, '70': 62.98, '80': 63.05 },
    '200': { '10': 60.51, '20': 61.01, '30': 61.43, '40': 61.78, '50': 62.06, '60': 62.26, '70': 62.4, '80': 62.46 }
  }
};

// Specific Heat data (Btu/lbm·°F) - Ethylene Glycol (key temperatures only)
const ethyleneGlycolSpecificHeat = {
  temperatures: [0, 20, 40, 60, 80, 100, 120, 140, 160, 180, 200],
  concentrations: [10, 20, 30, 40, 50, 60, 70, 80, 90],
  data: {
    '0': { '40': 0.823, '50': 0.739, '60': 0.656, '70': 0.615 },
    '20': { '20': 0.969, '30': 0.901, '40': 0.834, '50': 0.752, '60': 0.671, '70': 0.631, '80': 0.59, '90': 0.54 },
    '40': { '10': 1.023, '20': 0.975, '30': 0.91, '40': 0.844, '50': 0.765, '60': 0.686, '70': 0.646, '80': 0.605, '90': 0.553 },
    '60': { '10': 1.024, '20': 0.982, '30': 0.918, '40': 0.855, '50': 0.777, '60': 0.7, '70': 0.66, '80': 0.62, '90': 0.567 },
    '80': { '10': 1.026, '20': 0.988, '30': 0.927, '40': 0.865, '50': 0.789, '60': 0.714, '70': 0.674, '80': 0.635, '90': 0.58 },
    '100': { '10': 1.029, '20': 0.995, '30': 0.935, '40': 0.875, '50': 0.801, '60': 0.727, '70': 0.688, '80': 0.649, '90': 0.594 },
    '120': { '10': 1.032, '20': 1.002, '30': 0.943, '40': 0.885, '50': 0.812, '60': 0.74, '70': 0.702, '80': 0.663, '90': 0.607 },
    '140': { '10': 1.035, '20': 1.008, '30': 0.951, '40': 0.894, '50': 0.823, '60': 0.753, '70': 0.715, '80': 0.677, '90': 0.62 },
    '160': { '10': 1.039, '20': 1.015, '30': 0.959, '40': 0.904, '50': 0.834, '60': 0.765, '70': 0.727, '80': 0.69, '90': 0.633 },
    '180': { '10': 1.044, '20': 1.021, '30': 0.967, '40': 0.913, '50': 0.844, '60': 0.776, '70': 0.74, '80': 0.703, '90': 0.645 },
    '200': { '10': 1.049, '20': 1.028, '30': 0.975, '40': 0.922, '50': 0.855, '60': 0.787, '70': 0.752, '80': 0.716, '90': 0.658 }
  }
};

// Specific Heat data (Btu/lbm·°F) - Propylene Glycol (key temperatures only)
const propylenGlycolSpecificHeat = {
  temperatures: [0, 20, 40, 60, 80, 100, 120, 140, 160, 180, 200],
  concentrations: [10, 20, 30, 40, 50, 60, 70, 80, 90],
  data: {
    '0': { '40': 0.823, '50': 0.739, '60': 0.656, '70': 0.615 },
    '20': { '20': 0.969, '30': 0.901, '40': 0.834, '50': 0.752, '60': 0.671, '70': 0.631, '80': 0.59, '90': 0.54 },
    '40': { '10': 1.023, '20': 0.975, '30': 0.91, '40': 0.844, '50': 0.765, '60': 0.686, '70': 0.646, '80': 0.605, '90': 0.553 },
    '60': { '10': 1.024, '20': 0.982, '30': 0.918, '40': 0.855, '50': 0.777, '60': 0.7, '70': 0.66, '80': 0.62, '90': 0.567 },
    '80': { '10': 1.026, '20': 0.988, '30': 0.927, '40': 0.865, '50': 0.789, '60': 0.714, '70': 0.674, '80': 0.635, '90': 0.58 },
    '100': { '10': 1.029, '20': 0.995, '30': 0.935, '40': 0.875, '50': 0.801, '60': 0.727, '70': 0.688, '80': 0.649, '90': 0.594 },
    '120': { '10': 1.032, '20': 1.002, '30': 0.943, '40': 0.885, '50': 0.812, '60': 0.74, '70': 0.702, '80': 0.663, '90': 0.607 },
    '140': { '10': 1.035, '20': 1.008, '30': 0.951, '40': 0.894, '50': 0.823, '60': 0.753, '70': 0.715, '80': 0.677, '90': 0.62 },
    '160': { '10': 1.039, '20': 1.015, '30': 0.959, '40': 0.904, '50': 0.834, '60': 0.765, '70': 0.727, '80': 0.69, '90': 0.633 },
    '180': { '10': 1.044, '20': 1.021, '30': 0.967, '40': 0.913, '50': 0.844, '60': 0.776, '70': 0.74, '80': 0.703, '90': 0.645 },
    '200': { '10': 1.049, '20': 1.028, '30': 0.975, '40': 0.922, '50': 0.855, '60': 0.787, '70': 0.752, '80': 0.716, '90': 0.658 }
  }
};

export { ethyleneGlycolDensity, propylenGlycolDensity, ethyleneGlycolSpecificHeat, propylenGlycolSpecificHeat }
